<template>
  <div v-if="application" class="Action-list">
    <h2 v-if="title" class="Action-list__title">{{ title }}</h2>
    <ApplicationAction
      v-for="(action, index) in actions"
      :disabled="isSubmitted"
      :key="index"
      :action="action"
      :component="getComponent(action)"
      :defaultOpen="messageId === action.id"
    />
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import ApplicationAction from "./ApplicationAction";

export default {
  name: "ApplicationActionList",
  components: { ApplicationAction },
  props: {
    title: {
      type: String,
      default: ""
    },
    actions: {
      type: Array,
      required: true
    },
    actionType: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapState("applicationStore", ["application"]),
    ...mapGetters("applicationStore", ["applicationIsSubmitting"]),
    ...mapState("memberStore", ["messageId"]),
    isSubmitted() {
      return this.application.status === "SUBMITTED";
    }
  },
  methods: {
    getComponent(action) {
      if (action.type === "ATTACHMENT") {
        return "ApplicationActionAttachment";
      }
      if (action.type === "TEXT") {
        return "ApplicationActionText";
      }
      if (
        action.type === "SUPPLIERS" ||
        action.type === "EDUCATION" ||
        action.type === "GROUP_AFFILIATION" ||
        action.type === "WORKPSYCHOLOGY_POLICY"
      ) {
        return "ApplicationActionMeta";
      }
      if (action.type === "CONTACT") {
        return "ApplicationActionMeta";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.Action-list {
  margin-bottom: $spacing-L;
  position: relative;

  .Action-list + &:before {
    content: "";
    background: $color-border;
    height: $spacing-L;
    width: 1px;
    position: absolute;
    top: 0;
    left: 50%;
    margin-left: -$spacing-L;
  }

  &:after {
    content: "";
    background: $color-border;
    height: $spacing-L * 3;
    width: 1px;
    position: absolute;
    bottom: -$spacing-L;
    left: 50%;
    margin-left: -$spacing-L;
  }

  &--empty:after {
    height: auto;
    top: 0;
  }

  &:last-child:after {
    content: none;
  }

  &__title {
    @extend %text-S;
    color: $color-greyish-brown;
    margin-bottom: $spacing-S;
  }

  &__button {
    background: $color-pale-grey-two;
    display: block;
    margin: $spacing auto 0 auto;
    position: relative;
    left: -$spacing-L;
    z-index: $z-base;

    .Action-list--empty & {
      margin-top: 0;
    }
  }
}
</style>
